import { _messagebg } from 'src/styles/colors'
import { fontWeightMedium, fontWeightRegular } from 'src/styles/font'
import styled from 'styled-components'

export const MessageBottom = styled.div`
  font-size: 12px;
  line-height: 1;
  > * {
    margin: 0 8px;
    :first-child {
      margin: 0;
    }
    display: flex;
    align-items: center;
    svg {
      width: 1em;
      height: 1em;
      margin-right: 4px;
    }
  }
`
export const ReadMarker = styled.p`
  position: absolute;
  bottom: 0;
  left: -3em;
  font-size: 10px;
  font-weight: ${fontWeightMedium};
`
export const Timestamp = styled.p`
  font-size: 12px;
  font-weight: ${fontWeightRegular};
  width: fit-content;
`
export const ContentContainer = styled.div`
  position: relative;
  min-width: 108px;
`
export const ContentDiv = styled.div`
  font-size: 14px;
  font-weight: ${fontWeightMedium};
  letter-spacing: 0.036em;
  line-height: 1.5;
  white-space: pre-wrap;
  p {
    width: fit-content;
    padding: 8px;
    background: ${_messagebg};
    border-radius: 5px;
    margin-bottom: 4px;
    svg {
      flex-shrink: 0;
      width: 24px;
      margin: 0 16px;
    }
    a {
      text-decoration: underline;
      line-break: anywhere;
    }
  }
  button {
    display: block;
    img {
      max-width: 457px;
      max-height: 257px;
      object-fit: scale-down;
      border-radius: 5px;
      margin-bottom: 4px;
    }
  }
`

export const MessageDiv = styled.div`
  display: flex;
  position: relative;
  margin: 0 -4px;
  width: 100%;
  > div {
    max-width: 80%;
  }
  > * {
    margin: 0 4px;
  }
  ${ContentDiv} {
    margin-top: 8px;
  }
  ${MessageBottom} {
    position: absolute;
    display: flex;
    align-items: center;
    bottom: -1.5em;
    left: 48px;
    width: max-content;
  }
  /* NOTE: OS-1073 safari v13 で表示崩れが起きたため修正対応 */
  flex-shrink: 0;
`
